export default "__VITE_ASSET__TyPAu$r6__"